/*
 * amondz Coupon Resolver (v1.1)
 *
 * v1.2: 결제 시 뺀 미선택 상품을 돌아왔을 때 다시 담기(saveKept/restoreKept)
 * v1.1: 최대 할인 자동 적용 토글(bestSync/bestSetEnabled) — 후보를 한꺼번에 지정해 Shopify 최적 조합 판정 사용
 *
 * 쿠폰 적용 결과를 해석해 고객에게 알리는 공용 모듈 (장바구니 / 기획전 쿠폰 블록 / 기획전 배너 공통).
 *
 * 정책 — 병용 여부는 Shopify 할인 설정이 결정하고, 누가 이기는지는 Shopify 판정(applicable)을 그대로 따른다.
 * (Shopify 는 병용 불가 시 고객에게 유리한 쪽을 적용 — 결제 화면도 동일. 2026-09-29 장바구니·결제 화면 실측)
 *   - 새 쿠폰이 이김    → 밀려난 쿠폰은 카트에서 정리 + "切り替えました" 안내
 *   - 새 쿠폰이 짐      → 단독 적용으로 원인 판별(probe)
 *       · 단독이면 적용됨 → 병용 불가. 기존 쿠폰 유지 + [切り替える] 버튼 제공
 *       · 단독도 안 됨    → 조건 미충족. 기존 쿠폰 유지, 새 쿠폰은 대기로 남김(배송 쿠폰 등 결제 시 확정되는 것 보호)
 *   - VIP 포인트 코드(VIP-POINT-*)가 카트에 있으면 코드 목록을 절대 건드리지 않고 안내만 한다
 *     (포인트 코드는 재적용 위험 — cart-amondz.js 원칙과 동일)
 *
 * 코드 목록 변경은 /cart/update.js {discount: 'A,B'} (공식 Ajax API, 목록을 정확히 교체 — 실측 확인).
 * 적용 판정은 /cart.js discount_codes[].applicable (제품 할인 쿠폰도 여기에 뜸 — 실측 확인).
 *
 * 사용:
 *   azCoupon.recordAttempt(code)  → /discount/CODE 로 이동하기 직전에 호출 (적용 전 코드 목록 기록)
 *   azCoupon.resolve(cart)        → 이동 후 페이지에서 호출. {changed, notice} 반환
 *                                    changed=true 면 카트 코드 목록을 정리했음(장바구니는 리로드 필요)
 *   azCoupon.switchTo(code)       → 병용 불가로 밀린 쿠폰으로 교체
 *   azCoupon.applyInPlace(code)   → 장바구니용. 이동 없이 적용+판정 후 {notice} (포인트 있으면 {fallback:true})
 *   장바구니가 아닌 페이지는 로드 시 자동으로 resolve 후 토스트 안내
 */
(function() {
  'use strict';

  var ATTEMPT_KEY = 'az_coupon_attempt';
  var NOTICE_KEY = 'az_coupon_notice';
  var RESTORE_KEY = 'az_coupon_restore';  // probe 도중 이탈 대비 — 복원할 코드 목록
  var ATTEMPT_TTL = 60000;

  function lower(s) { return String(s || '').toLowerCase(); }
  function has(list, code) {
    var t = lower(code);
    return list.some(function(c) { return lower(c) === t; });
  }
  // 문구는 snippets/az-i18n.liquid(window.azT)에서. 문구 조각이 없는 페이지(빈 장바구니 등)에서는 빈 문자열
  function azT(key, vars) { return window.azT ? window.azT(key, vars) : ''; }
  function quote(list) { var o = azT('qo'), c = azT('qc'); return o + list.join(c + o) + c; }

  function isPointCode(code) { return /VIP-?POINT/i.test(code || ''); }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function(res) { return res.json(); });
  }

  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function(res) {
      if (!res.ok) throw new Error('discount update failed: ' + res.status);
      return res.json();
    });
  }

  function allCodes(cart) {
    return (cart.discount_codes || []).map(function(d) { return d.code; }).filter(Boolean);
  }

  // 실제로 할인이 걸린 코드 — applicable 우선, 금액 할당(주문/제품)에 잡힌 코드 제목도 포함
  function appliedCodes(cart) {
    var out = [];
    function add(c) { if (c && !has(out, c)) out.push(c); }
    (cart.discount_codes || []).forEach(function(d) { if (d && d.applicable) add(d.code); });
    (cart.cart_level_discount_applications || []).forEach(function(a) {
      if (a && a.type === 'discount_code') add(a.title);
    });
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(al) {
        var app = al && al.discount_application;
        if (app && app.type === 'discount_code') add(app.title);
      });
    });
    return out;
  }

  function isApplied(cart, code) { return has(appliedCodes(cart), code); }

  function readAttempt() {
    var raw = null;
    try { raw = sessionStorage.getItem(ATTEMPT_KEY); sessionStorage.removeItem(ATTEMPT_KEY); } catch (e) {}
    if (!raw) return null;
    var o = null;
    try { o = JSON.parse(raw); } catch (e) { o = { c: raw }; }
    if (!o || !o.c) return null;
    if (o.t && Date.now() - o.t > ATTEMPT_TTL) return null;  // 오래된 기록 폐기
    return o;
  }

  function writeAttempt(o) {
    try { sessionStorage.setItem(ATTEMPT_KEY, JSON.stringify(o)); } catch (e) {}
  }

  // /discount/CODE 이동 직전에 호출 — 적용 전 코드 목록을 함께 기록해 두면 "무엇이 밀렸는지" 판정 가능.
  // 카트 조회 실패 시에도 이동은 막지 않는다(prev=null → 밀린 쿠폰 안내만 생략).
  function recordAttempt(code, extra) {
    var o = { c: String(code || '').trim(), t: Date.now(), prev: null };
    if (extra) for (var k in extra) o[k] = extra[k];
    return fetchCart().then(function(cart) {
      o.prev = appliedCodes(cart);
      writeAttempt(o);
    }, function() {
      writeAttempt(o);
    });
  }

  function without(list, drop) {
    return list.filter(function(c) { return !has(drop, c); });
  }

  // probe 처럼 코드 목록을 잠시 바꾸는 작업은 복원 목록을 먼저 저장 → 도중에 페이지를 떠나도 다음 로드에서 복원.
  function guardedSet(tempCodes, restoreCodes) {
    try { sessionStorage.setItem(RESTORE_KEY, JSON.stringify({ codes: restoreCodes, t: Date.now() })); } catch (e) {}
    return setCodes(tempCodes);
  }
  function finishSet(codes) {
    return setCodes(codes).then(function(r) {
      try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
      return r;
    });
  }
  function pendingRestore() {
    try {
      var raw = sessionStorage.getItem(RESTORE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.codes || (o.t && Date.now() - o.t > 10 * 60000)) { sessionStorage.removeItem(RESTORE_KEY); return null; }
      return o.codes;
    } catch (e) { return null; }
  }

  // 처리할 시도 기록이나 복원 마커가 있는지 — 장바구니는 이때만 버튼을 잠그고 resolve 를 기다린다
  function recoverPending() {
    var restore = pendingRestore();
    if (!restore) return Promise.resolve();
    return finishSet(restore).then(null, function() {});
  }

  function hasAttempt() {
    try { return !!(sessionStorage.getItem(ATTEMPT_KEY) || sessionStorage.getItem(RESTORE_KEY)); } catch (e) { return false; }
  }


  function resolve(cart) {
    if (!cart) return Promise.resolve({ changed: false, notice: null });

    // 직전 probe 가 도중에 끊겼으면 먼저 원래 목록으로 복원
    var restore = pendingRestore();
    if (restore) {
      try { sessionStorage.removeItem(ATTEMPT_KEY); } catch (e) {}
      // 복원은 코드 목록만 되돌리므로 최대할인 서명도 비워 다음 로드에 다시 계산(서명만 최신인 채 고착 방지)
      return updateCart({ discount: restore.join(','), attributes: { _az_best_sig: '' } }).then(function() {
        try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
      }).then(
        function() { return { changed: true, notice: null }; },
        function() { return { changed: false, notice: null }; }
      );
    }

    // 새 방문이면 지난 방문에 켜 둔 토글을 끄고 시작(장바구니가 다시 그려지도록 changed). 시도 기록은 다음 로드에서 처리
    return bestVisitReset(cart).then(function(reset) {
      return reset ? { changed: true, notice: null } : resolveWith(cart, readAttempt());
    }).then(function(res) {
      // 장바구니 로드 잠금 중(포인트 감지 폴링 전)에 끝내야 시험 적용이 금액 갱신·리로드를 일으키지 않음
      if (res.changed) return res;
      return bestRecheck(cart).then(function(changed) {
        return changed ? { changed: true, notice: null } : bestHintProbe(cart).then(function() { return res; });
      });
    });
  }

  // ── 꺼짐: 이 고객에게 실제로 적용되는 후보가 있는지 → 토글 활성/비활성 + 안내 ──
  // Shopify 는 고객 대상(세그먼트 등)을 로그인 고객 기준으로 applicable 에 반영(비로그인은 통과 → 토글 잠금 유지).
  // 페이지 로드마다(로드 잠금 중) 후보를 손님 코드와 함께 잠깐 넣어 applicable 확인 → 바로 원래 목록으로 복원(복원 마커로 이탈 대비).
  // 판정 전 토글은 대기(data-az-best-pending, 회색·못 켬). 있음 → 활성 + 「…あります」 / 없음·실패·시간초과 → 비활성(없음일 때만 「…ありません」).
  // 결과는 이 페이지 메모리에만(수량 변경으로 안내 줄만 다시 그려질 때 재사용) — 자격 변경을 놓치지 않게 탭 저장 안 함.
  // 포인트 코드가 있으면 코드 목록을 건드리지 않음 → 토글은 기존처럼 활성, 안내 숨김.
  var bestHintMem = null;   // { node, ok } 이번 페이지 판정
  function bestHintTargets() {
    var hint = document.querySelector('[data-az-best-available-hint]');
    var toggle = document.querySelector('[data-az-best-toggle]');
    if (!hint || !toggle || toggle.getAttribute('aria-checked') === 'true') return null;
    return { hint: hint, toggle: toggle };
  }
  // ok: true 있음 / false 없음 / null 실패 / 'skip' 판정 안 함(포인트)
  function bestHintShow(t, ok) {
    var toggle = t.toggle, hint = t.hint;
    bestHintMem = { node: hint, ok: ok };
    toggle.removeAttribute('data-az-best-pending');
    if (ok === true || ok === 'skip') {
      toggle.classList.remove('az-best--disabled');
      toggle.removeAttribute('aria-disabled');
    } else {
      toggle.disabled = true;
      toggle.classList.add('az-best--disabled');
      toggle.setAttribute('aria-disabled', 'true');
    }
    if (ok !== true && ok !== false) { hint.hidden = true; return; }
    hint.innerHTML = hint.getAttribute(ok ? 'data-yes' : 'data-no') || '';  // 테마 문구(<wbr> 줄바꿈 위치 포함)
    hint.hidden = false;
    hint.style.visibility = 'visible';
  }
  function bestHintProbe(cart) {
    var t = bestHintTargets();
    if (!t || t.toggle.disabled) return Promise.resolve();
    var codes = allCodes(cart);
    if (codes.some(isPointCode) || bestIsOn(cart)) { bestHintShow(t, 'skip'); return Promise.resolve(); }
    var fresh = bestCandidates(cart, String(t.toggle.getAttribute('data-candidates') || '').split(',').map(function(c) { return c.trim(); }))
      .filter(function(c) { return !has(codes, c); });  // 손님이 이미 넣은 코드·解除 한 코드는 제외
    if (!fresh.length) { bestHintShow(t, false); return Promise.resolve(); }
    var set = codes.slice(0, BEST_MAX);
    fresh.forEach(function(c) { if (set.length < BEST_MAX) set.push(c); });
    // 먼저 비우고 다시 지정해야 Shopify 가 고객 자격을 새로 판정(같은 목록 재지정은 이전 판정 유지 — 2026-10-27 실측). 원래 목록은 복원 마커에
    var probe = guardedSet([], codes).then(function() { return setCodes(set); }).then(function(after) {
      var applied = appliedCodes(after);
      var ok = fresh.some(function(c) { return has(applied, c); });
      return finishSet(codes).then(function() { return ok; });
    });
    var timeout = new Promise(function(resolve) { setTimeout(function() { resolve(null); }, 6000); });
    return Promise.race([probe, timeout]).then(function(ok) { bestHintShow(t, ok); }, function() { bestHintShow(t, null); });
  }
  // 수량 변경 등으로 안내 줄만 새로 그려지면(토글은 유지됨) 이번 페이지 판정으로 다시 표시
  function bestHintRefresh() {
    if (!bestHintMem) return;  // 첫 판정 전(로드 중)은 resolve 가 처리
    var t = bestHintTargets();
    if (!t || t.hint === bestHintMem.node) return;
    bestHintShow(t, bestHintMem.ok);
  }

  // ── 켜짐: 토글이 넣어 둔 코드가 지금도 이 고객에게 적용되는지 페이지 로드마다 재확인 ──
  // 코드 목록을 비운 뒤 다시 지정해 Shopify 재판정(같은 목록 재지정만으론 이전 판정 유지) → 적용 안 되는 자동 코드는 빼고,
  // 하나도 안 남으면 토글 끔(리로드 후 비활성 판정). 비운 사이 이탈하면 복원 마커가 원래 목록으로 되돌림.
  // 손님 직접 코드는 유지, 포인트 코드가 있으면 건드리지 않음. 반복 리로드는 bestGuardOk 로 막음.
  function bestRecheck(cart) {
    if (!bestIsOn(cart)) return Promise.resolve(false);
    var codes = allCodes(cart);
    if (codes.some(isPointCode)) return Promise.resolve(false);
    var auto = attrList(cart, '_az_best_codes');
    var off = { _az_best_coupon: 'off', _az_best_codes: '', _az_best_sig: '' };
    var run;
    if (!auto.length) {
      // 켜져 있지만 적용된 자동 코드가 없음 = 이 고객에게 쓸 후보 없음 → 끔
      run = bestGuardOk() ? updateCart({ attributes: off }).then(function() { return true; }) : Promise.resolve(false);
    } else {
      run = guardedSet([], codes).then(function() { return setCodes(codes); }).then(function(after) {
        var applied = appliedCodes(after);
        var lost = auto.filter(function(c) { return !has(applied, c); });
        if (!lost.length) {
          try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
          return after.total_price !== cart.total_price && bestGuardOk();  // 금액만 바뀜 → 다시 그림
        }
        var keep = without(auto, lost);
        return updateCart({
          discount: without(codes, lost).join(','),
          attributes: keep.length ? { _az_best_codes: keep.join(',') } : off
        }).then(function() {
          try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
          return true;  // 카트가 바뀌었으니 다시 그림(다음 로드엔 빠진 코드가 없어 반복 안 됨)
        });
      });
    }
    var timeout = new Promise(function(resolve) { setTimeout(function() { resolve(false); }, 6000); });
    return Promise.race([run, timeout]).then(null, function() { return false; });
  }

  // ── 최대할인 토글: 방문마다 꺼짐으로 시작 ──
  // 이 탭에서 켰으면(sessionStorage 'on') 유지 → 장바구니↔결제 왕복은 그대로. 새 탭·새 방문은 기록이 없어 꺼짐으로 시작.
  // 끌 때는 토글이 넣은 자동 코드(_az_best_codes)만 빼고 손님이 직접 넣은 코드는 유지.
  // 포인트 코드가 있으면 코드 목록을 건드리지 않음(포인트 원칙) — 그 방문은 기존 상태 그대로.
  // 방문 중 로그인/로그아웃하면(다른 사람·다른 카트일 수 있음) 새 방문으로 봄 — Shopify 가 넣는 __st.cid(로그인 고객) 기준
  function bestVisitKey() { return 'az_best_visit:' + ((window.__st && window.__st.cid) || 'guest'); }
  function bestVisitMark(v) { try { sessionStorage.setItem(bestVisitKey(), v); } catch (e) {} }
  function bestVisitReset(cart) {
    return bestVisitResetRun(cart).then(function(reset) {
      // 초기화(→ 리로드)하지 않으면 main-cart-items 가 가려 둔 카트를 바로 표시
      if (!reset) document.documentElement.classList.remove('az-best-checking');
      return reset;
    });
  }
  function bestVisitResetRun(cart) {
    var v = null;
    try { v = sessionStorage.getItem(bestVisitKey()); } catch (e) { return Promise.resolve(false); }
    if (v) return Promise.resolve(false);
    bestVisitMark('seen');
    var auto = attrList(cart, '_az_best_codes');
    if (!bestIsOn(cart) && !auto.length) return Promise.resolve(false);
    var codes = allCodes(cart);
    if (codes.some(isPointCode)) return Promise.resolve(false);
    return updateCart({
      discount: codes.filter(function(c) { return !has(auto, c); }).join(','),
      attributes: { _az_best_coupon: 'off', _az_best_codes: '', _az_best_sig: '' }
    }).then(function() { return true; }, function() { return false; });
  }

  function resolveWith(cart, att) {
    if (!att) return Promise.resolve({ changed: false, notice: null });

    var code = att.c;
    var codes = allCodes(cart);
    var hasPoint = codes.some(isPointCode);
    var applied = appliedCodes(cart);

    // ── 새 쿠폰이 적용됨 ──
    if (has(applied, code)) {
      var knocked = (att.prev || []).filter(function(c) {
        return lower(c) !== lower(code) && !isPointCode(c) && !has(applied, c);
      });
      // 포인트 코드가 밀렸으면(적용 안 됨) 반드시 알린다 — 포인트 코드 자체는 손대지 않음
      var pointKnocked = codes.some(function(c) { return isPointCode(c) && !has(applied, c); });
      var texts = [];
      if (knocked.length) texts.push(azT('coupon_switched', { knocked: quote(knocked), code: code }));
      if (pointKnocked) texts.push(azT('point_knocked_by_coupon'));
      if (!texts.length) return Promise.resolve({ changed: false, notice: null });

      var notice = { type: 'info', text: texts.join('') };
      // 밀린 쿠폰만 카트에서 정리(나중에 조용히 되살아나지 않게). 대기 중인 다른 코드는 유지. 포인트 있으면 손대지 않음.
      var stale = codes.filter(function(c) { return has(knocked, c); });
      if (hasPoint || !stale.length) return Promise.resolve({ changed: false, notice: notice });
      return setCodes(without(codes, stale)).then(
        function() { return { changed: true, notice: notice }; },
        function() { return { changed: false, notice: notice }; }
      );
    }

    // ── 새 쿠폰이 적용 안 됨 ──
    var conditionNotice = {
      type: 'error',
      text: azT('coupon_unusable', { code: code })
    };

    // 코드가 카트 목록에 남아 있으면 무효 코드가 아님 — 배송비 쿠폰처럼 결제 단계에서 판정되는 쿠폰일 수 있어
    // "사용 불가" 단정 대신 중립 안내(조건 미충족 일반 쿠폰도 같은 상태라 조건 확인 문구를 함께 둠)
    if (has(codes, code)) {
      conditionNotice = {
        type: 'info',
        text: azT('coupon_accepted_unconfirmed', { code: code })
      };
    }

    // 교체(switch) 결과 실패 → 교체 전 목록으로 되돌림(기존 쿠폰 유실 방지)
    if (att.mode === 'switch' && att.restore && att.restore.length) {
      return setCodes(att.restore).then(
        function() { return { changed: true, notice: conditionNotice }; },
        function() { return { changed: false, notice: conditionNotice }; }
      );
    }

    if (hasPoint) {
      // 포인트 코드가 있으면 probe(목록 교체) 불가 → 원인 단정 없이 안내만
      return Promise.resolve({ changed: false, notice: {
        type: 'error',
        text: azT('coupon_apply_failed_point', { code: code })
      } });
    }

    var winners = applied.filter(function(c) { return lower(c) !== lower(code); });
    // 카트에 코드가 없음 = 무효 코드이거나 /discount 이동이 실제로 일어나지 않음 → 목록은 건드리지 않음
    if (!winners.length || !has(codes, code)) return Promise.resolve({ changed: false, notice: conditionNotice });

    // probe: 새 쿠폰 단독으로 적용해 보고 → 원래 목록으로 복원 (복원 목록 선저장)
    return guardedSet([code], codes)
      .then(fetchCart)
      .then(function(probeCart) {
        var aloneOk = isApplied(probeCart, code);
        // 병용 불가 → 새 쿠폰 제거하고 기존 유지 / 조건 미충족 → 원래 목록 그대로(새 쿠폰은 대기)
        return finishSet(aloneOk ? without(codes, [code]) : codes).then(function() {
          if (!aloneOk) return { changed: true, notice: conditionNotice };
          return { changed: true, notice: {
            type: 'info',
            text: azT('coupon_not_combinable', { code: code, winners: quote(winners) }),
            switchCode: code
          } };
        });
      })
      .catch(function() {
        // probe 도중 실패 → 원래 목록 복원 재시도. 그래도 실패하면 복원 마커가 남아 다음 로드에서 재시도.
        return finishSet(codes).then(null, function() {}).then(function() {
          return { changed: true, notice: {
            type: 'error',
            text: azT('coupon_apply_retry', { code: code })
          } };
        });
      });
  }

  // 장바구니용: 페이지 이동 없이 적용 + 결과 판정까지 요청만으로 끝낸다(/discount 이동 → 리로드 2회를 1회로).
  // /cart/update.js 에 기존 코드 + 새 코드를 지정하면 Shopify 가 /discount 방문과 같은 판정을 한다(실측).
  // 포인트 코드가 있으면 목록 재지정 불가 → {fallback:true} (호출 측이 /discount 이동 방식으로 처리).
  // 반환 {fallback} 또는 {notice} — 카트는 항상 바뀌었으므로 호출 측은 리로드한다.
  function applyInPlace(code) {
    code = String(code || '').trim();
    return fetchCart().then(function(cart) {
      var codes = allCodes(cart);
      if (codes.some(isPointCode)) return { fallback: true };
      var att = { c: code, t: Date.now(), prev: appliedCodes(cart) };
      var next = has(codes, code) ? codes : codes.concat([code]);
      // 도중 이탈 대비: 원래 목록을 복원 마커로 저장한 뒤 변경
      return guardedSet(next, codes)
        .then(fetchCart)
        .then(function(after) { return resolveWith(after, att); })
        .then(function(res) {
          try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}  // 최종 상태 도달
          return { notice: res.notice };
        });
    });
  }

  // 병용 불가로 밀린 쿠폰으로 교체 — 목록을 그 쿠폰 하나로 바꾸고, 다음 로드의 resolve 가 결과를 안내.
  // 교체 직전에 포인트 코드가 생겼으면 중단(포인트 코드는 목록에서 빼지 않음). 실패 시 되돌릴 목록을 기록.
  function switchTo(code) {
    return fetchCart().then(function(cart) {
      var codes = allCodes(cart);
      if (codes.some(isPointCode)) {
        saveNotice({ type: 'error', text: azT('coupon_switch_blocked_point') });
        return;
      }
      writeAttempt({ c: code, t: Date.now(), prev: appliedCodes(cart), mode: 'switch', restore: codes });
      var auto = attrList(cart, '_az_best_codes');
      if (!auto.length) return setCodes([code]);
      // 최대할인 토글이 넣은 코드를 고객이 교체로 밀어냄 → 다시 자동으로 넣지 않도록 제외 목록에
      var skip = attrList(cart, '_az_best_skip');
      auto.forEach(function(c) { if (!has(skip, c) && lower(c) !== lower(code)) skip.push(c); });
      return updateCart({ discount: code, attributes: { _az_best_codes: '', _az_best_skip: skip.join(',') } });
    });
  }

  // ── 최대 할인 자동 적용 (enable_best_coupon 토글) ────────────────────────────
  // 후보(기획전 쿠폰, Liquid 가 data-candidates 로 전달)를 고객이 직접 넣은 코드와 함께 한꺼번에 지정 →
  // Shopify 가 병용 설정대로 최적 조합을 고른다(실측: 순서 무관, 4개 중 최대 할인 조합 선택).
  // 진 후보는 정리하고, 직접 넣은 코드는 (밀려도) 남긴다. 상태는 카트 속성에 저장:
  //   _az_best_coupon: 'on' 이면 켜짐(기본 꺼짐). 값이 없는데 _az_best_codes 가 있으면 기존(기본 켜짐 시절) 카트 → 켜짐 유지 / _az_best_codes: 토글이 넣어 적용된 코드
  //   _az_best_skip: 고객이 解除 한 자동 코드(다시 넣지 않음) / _az_best_sig: 마지막 계산 시점의 후보+카트 서명
  var BEST_MAX = 5;  // Shopify: 주문당 상품·주문 할인 코드 최대 5개
  var BEST_GUARD_KEY = 'az_best_syncs';

  function attrList(cart, key) {
    var v = (cart.attributes || {})[key];
    return v ? String(v).split(',').map(function(c) { return c.trim(); }).filter(Boolean) : [];
  }

  function updateCart(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      if (!res.ok) throw new Error('cart update failed: ' + res.status);
      return res.json();
    });
  }

  function bestCandidates(cart, candidates) {
    var skip = attrList(cart, '_az_best_skip');
    // 비로그인(cart-coupon.liquid 가 토글을 disabled 로 렌더) → 자동 후보 없음. 예전에 켜 둔 카트 속성이 남아 있어도 자동 코드는 정리됨
    var toggle = document.querySelector('[data-az-best-toggle]');
    if (toggle && toggle.disabled) return [];
    return (candidates || []).filter(function(c) { return c && !has(skip, c); });
  }

  // 카트 상품 구성 + 후보가 같으면 이미 계산한 상태 → 다시 하지 않음(리로드 루프 방지)
  function bestSig(cart, cands) {
    var qty = {};
    (cart.items || []).forEach(function(i) { qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
    var items = Object.keys(qty).map(function(v) { return v + ':' + qty[v]; }).sort();
    return items.join('|') + '#' + cands.map(lower).sort().join(',') + '#points:' + allCodes(cart).filter(isPointCode).map(lower).sort().join(',');
  }

  function bestIsOn(cart) {
    var a = cart.attributes || {};
    return a._az_best_coupon === 'on' || (a._az_best_coupon !== 'off' && !!a._az_best_codes);
  }

  function bestNeedsSync(cart, candidates) {
    if (!bestIsOn(cart)) return false;
    return (cart.attributes || {})._az_best_sig !== bestSig(cart, bestCandidates(cart, candidates));
  }

  // A point-only update keeps the already validated coupon combination.
  // Carry its signature forward with the new point code in the same cart request.
  function bestPointUpdateAttrs(cart, codes, candidates) {
    if (!bestIsOn(cart) || bestNeedsSync(cart, candidates)) return {};
    var next = Object.assign({}, cart, {discount_codes:codes.map(function(code){return {code:code};})});
    return {_az_best_sig:bestSig(next, bestCandidates(next, candidates))};
  }

  // 짧은 시간에 반복 동기화되면(속성 저장 실패 등) 중단 — 무한 리로드 방지
  function bestGuardOk() {
    try {
      var now = Date.now();
      var arr = JSON.parse(sessionStorage.getItem(BEST_GUARD_KEY) || '[]').filter(function(t) { return now - t < 15000; });
      if (arr.length >= 2) return false;
      arr.push(now);
      sessionStorage.setItem(BEST_GUARD_KEY, JSON.stringify(arr));
      return true;
    } catch (e) { return true; }
  }

  // 반환 {changed, notice}. changed=true 면 카트가 바뀌었으니 호출 측이 리로드.
  // 코드 목록을 바꾸기 직전에 카트를 다시 읽어 포인트 코드가 새로 붙었으면 중단(판정 사이 VIP 적용 경합 방지).
  function bestSync(cart, candidates, force, confirmedSnapshot) {
    if (!bestIsOn(cart)) return Promise.resolve({ changed: false, notice: null });
    var cands0 = bestCandidates(cart, candidates);
    if (!force && (cart.attributes || {})._az_best_sig === bestSig(cart, cands0)) return Promise.resolve({ changed: false, notice: null });
    if (!force && !bestGuardOk()) return Promise.resolve({ changed: false, notice: null });

    return (confirmedSnapshot ? Promise.resolve(confirmedSnapshot) : fetchCart()).then(function(fresh) {
      var codes = allCodes(fresh);
      if (codes.some(isPointCode)) {
        if (!window.azVipCouponWithPoints) return { changed: false, notice: null, blocked: 'point' };
        return syncCouponWithPoints(true, candidates, fresh);
      }
      var cands = bestCandidates(fresh, candidates);
      var sig = bestSig(fresh, cands);
      var prevAuto = attrList(fresh, '_az_best_codes');
      // 직접 넣은 코드 = 토글이 넣지 않은 코드 전부(후보와 같은 코드를 고객이 직접 넣었어도 직접 코드로 취급)
      var manual = codes.filter(function(c) { return !has(prevAuto, c); });
      var set = manual.slice(0, BEST_MAX);
      cands.forEach(function(c) { if (set.length < BEST_MAX && !has(set, c)) set.push(c); });
      var appliedBefore = appliedCodes(fresh);

      // 할인 갱신 응답에 최신 cart가 포함되므로 별도 조회 없이 판정한다.
      return guardedSet(set, codes)
        .then(function(after) {
          var applied = appliedCodes(after);
          var autoWon = cands.filter(function(c) { return has(applied, c) && !has(manual, c); });
          // 진 후보는 제거(숨은 채 남지 않게), 직접 넣은 코드는 밀려도 유지
          var finalCodes = set.filter(function(c) { return has(manual, c) || has(applied, c); });
          var knockedManual = manual.filter(function(c) { return has(appliedBefore, c) && !has(applied, c); });
          var notice = (knockedManual.length && autoWon.length) ? {
            type: 'info',
            text: azT('best_knocked', { knocked: quote(knockedManual), won: quote(autoWon) })
          } : null;
          return updateCart({
            discount: finalCodes.join(','),
            attributes: { _az_best_codes: autoWon.join(','), _az_best_sig: sig }
          }).then(function(updated) {
            try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
            return { changed: true, notice: notice, cart:updated };
          });
        });
    });
  }

  // 토글 켜기/끄기. 끄기 = 토글이 넣은 코드만 제거(직접 넣은 코드는 유지). 포인트 사용 중에는 기존 코드와 할인액 유지 여부를 검증.
  // Keep the VIP hold/code when Shopify can apply the new coupons without
  // changing the point discount. Never infer success from the switch alone.
  function pointAllocated(cart) {
    var total = 0;
    (cart.cart_level_discount_applications || []).forEach(function(a) {
      if (isPointCode(a.title)) total += Number(a.total_allocated_amount) || 0;
    });
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(a) {
        if (isPointCode((a.discount_application || {}).title)) total += Number(a.amount) || 0;
      });
    });
    return total;
  }

  async function keepPointCouponChange(on, candidates, before) {
    var original = allCodes(before), points = original.filter(isPointCode);
    var amount = pointAllocated(before);
    var rows = Array.from(document.querySelectorAll('[data-az-item]'));
    // Partial selections require the existing point-cap transaction.
    if (rows.some(function(row) { var check = row.querySelector('input[type=checkbox]'); return !check || !check.checked; })) return null;
    if (points.length !== 1 || amount <= 0 || !isApplied(before, points[0])) return null;
    var originalAttrs = before.attributes || {};
    var prevAuto = attrList(before, '_az_best_codes');
    var manual = original.filter(function(code) { return !has(prevAuto, code); });
    if (manual.length > BEST_MAX) return null;
    var planned = manual.slice();
    var cands = on ? (candidates || []).filter(Boolean) : [];
    cands.forEach(function(code) { if (planned.length < BEST_MAX && !has(planned, code)) planned.push(code); });
    function samePoint(cart) {
      var now = allCodes(cart).filter(isPointCode);
      return Number.isFinite(Number(cart.total_price)) && Number(cart.total_price) >= 0 && now.length === 1 && has(now, points[0]) && isApplied(cart, points[0]) && pointAllocated(cart) === amount;
    }
    async function restore() {
      var restored = await updateCart({discount:original.join(','),attributes:{
        _az_best_coupon:originalAttrs._az_best_coupon || '',
        _az_best_codes:originalAttrs._az_best_codes || '',
        _az_best_skip:originalAttrs._az_best_skip || '',
        _az_best_sig:originalAttrs._az_best_sig || ''
      }});
      if (!samePoint(restored)) restored = await fetchCart();
      if (!samePoint(restored)) throw new Error('Original point discount could not be restored');
      try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
      return restored;
    }
    try {
      var after = await guardedSet(planned, original);
      if (!samePoint(after)) after = await fetchCart();
      if (!samePoint(after)) { await restore(); return null; }
      var applied = appliedCodes(after);
      var autoWon = cands.filter(function(code) { return has(applied, code) && !has(manual, code); });
      var finalCodes = planned.filter(function(code) { return has(manual, code) || has(applied, code); });
      var next = Object.assign({}, after, {discount_codes:finalCodes.map(function(code) { return {code:code}; })});
      var updated = await updateCart({discount:finalCodes.join(','),attributes:{
        _az_best_coupon:on ? 'on' : 'off', _az_best_codes:autoWon.join(','),
        _az_best_skip:on ? '' : (originalAttrs._az_best_skip || ''),
        _az_best_sig:on ? bestSig(next, cands) : ''
      }});
      if (!samePoint(updated)) updated = await fetchCart();
      if (!samePoint(updated)) { await restore(); return null; }
      try { sessionStorage.removeItem(RESTORE_KEY); } catch (e) {}
      var knockedManual = manual.filter(function(code) { return !isPointCode(code) && isApplied(before, code) && !isApplied(updated, code); });
      var notice = knockedManual.length && autoWon.length ? {type:'info',text:azT('best_knocked', { knocked: quote(knockedManual), won: quote(autoWon) })} : null;
      // 포인트가 이겨 토글 쿠폰이 붙지 못함(병용 불가) → 안내
      var blocked = cands.filter(function(code) { return !has(applied, code) && !has(manual, code); });
      if (!notice && on && blocked.length) notice = {type:'info',text:azT('coupon_blocked_by_point', { code: blocked.join(azT('qc') + azT('qo')) })};
      return {changed:true,notice:notice,cart:updated};
    } catch (error) {
      // A failed rollback must stop the transaction; do not issue new points on
      // top of an unconfirmed state. The reload recovery marker is retained.
      await restore();
      throw error;
    }
  }

  function syncCouponWithPoints(on, candidates, cart) {
    return keepPointCouponChange(on, candidates, cart).then(function(kept) {
      if (kept) return kept;
      return window.azVipCouponWithPoints(on, candidates, bestSetEnabled, cart);
    }).then(function(result) {
      return (result.cart ? Promise.resolve(result.cart) : fetchCart()).then(function(finalCart) {
        // OFF needs no sync signature. ON may already be stamped by the point update.
        if (!bestIsOn(finalCart) || !bestNeedsSync(finalCart, candidates)) return result;
        return updateCart({attributes:{_az_best_sig:bestSig(finalCart,bestCandidates(finalCart,candidates))}}).then(function(){return result;});
      });
    });
  }

  function bestSetEnabled(on, candidates, snapshot) {
    bestVisitMark(on ? 'on' : 'seen');
    return (snapshot ? Promise.resolve(snapshot) : fetchCart()).then(function(cart) {
      var hasPoint = allCodes(cart).some(isPointCode);
      if (hasPoint && !on && !attrList(cart, '_az_best_codes').length) {
        // 제거할 자동 쿠폰이 없으면 포인트 발급 상태는 그대로 둔다.
        return updateCart({attributes:{_az_best_coupon:'off',_az_best_sig:''}}).then(function(updated){return {changed:true,notice:null,cart:updated};});
      }
      if (hasPoint && window.azVipCouponWithPoints) return syncCouponWithPoints(on, candidates, cart);
      if (on) {
        return updateCart({ attributes: { _az_best_coupon: 'on', _az_best_skip: '', _az_best_sig: '' } })
          .then(function(c2) { return hasPoint ? { changed: true, notice: null } : bestSync(c2, candidates, true, c2); });
      }
      var auto = attrList(cart, '_az_best_codes');
      var payload = { attributes: { _az_best_coupon: 'off', _az_best_sig: '' } };
      if (!hasPoint) {
        payload.discount = allCodes(cart).filter(function(c) { return !has(auto, c); }).join(',');
        payload.attributes._az_best_codes = '';
      }  // 포인트 사용 중엔 코드 불변 + 자동 코드 목록 유지(포인트 취소 후 끄면 그때 제거)
      return updateCart(payload).then(function(updated) { return { changed: true, notice: null, cart:updated }; });
    });
  }

  // 고객이 解除 한 코드가 자동 적용분이면 → 제외 목록에 넣어 다시 자동으로 넣지 않음(속성 payload 반환)
  function bestRemovalAttrs(cart, code, candidates) {
    var auto = attrList(cart, '_az_best_codes');
    // 자동 적용분이거나 후보(고객이 직접 넣은 기획전 코드 포함)면 제외 — 안 그러면 재계산이 바로 되살림
    if (!has(auto, code) && !has(candidates || [], code)) return null;
    var skip = attrList(cart, '_az_best_skip');
    if (!has(skip, code)) skip.push(code);
    return { _az_best_codes: without(auto, [code]).join(','), _az_best_skip: skip.join(',') };
  }

  // ── 결제 시 뺀 미선택 상품 유지 ──────────────────────────────────────────
  // 체크박스 부분 결제는 결제 직전에 미선택 줄을 카트에서 빼는 방식(Shopify 에 부분 결제가 없음).
  // 뺀 줄을 이 탭의 sessionStorage 에 기록 → 스토어로 돌아오면(구매 완료 후든, 결제 화면에서 뒤로든) 빠진 수량만 다시 담음.
  //   구매 완료: Shopify 가 구매분을 비움 → 미선택 상품만 남음 / 미구매 복귀: 원래 카트 그대로
  // 탭 단위(sessionStorage): 다른 탭에서 결제 중인 카트에 상품이 섞여 들어가지 않게.
  var KEPT_KEY = 'az_cart_kept';
  var KEPT_TTL = 24 * 60 * 60000;
  var KEPT_TRIES = 2;        // 실패 시 다음 페이지 로드에서 한 번 더 — 그래도 안 되면 기록 삭제(무한 재시도 방지)
  var KEPT_YOUNG = 60000;    // 기록 직후엔 "뺄 줄이 아직 카트에 있음" = 삭제 요청이 늦게 반영 중일 수 있음 → 기록 유지
  var KEPT_REQ_MS = 10000;   // 요청 하나의 제한 시간(전체 제한 없음 — 진행 중인 다시 담기를 끊지 않음)

  function samePropsKept(a, b) {
    var pa = a || {}, pb = b || {};
    var ka = Object.keys(pa).sort(), kb = Object.keys(pb).sort();
    if (ka.join('|') !== kb.join('|')) return false;
    return ka.every(function(k) { return String(pa[k]) === String(pb[k]); });
  }

  // lines: [{id, quantity, properties?, selling_plan?, keep}] — keep = 결제에 남긴 같은 옵션·속성 줄의 수량
  // 빈 목록 = 전부 선택해 결제 → 예전 기록 삭제(구매 완료 후 예전 미선택분이 다시 담기지 않게)
  function saveKept(lines) {
    try {
      if (!lines || !lines.length) { sessionStorage.removeItem(KEPT_KEY); return; }
      sessionStorage.setItem(KEPT_KEY, JSON.stringify({ lines: lines, t: Date.now(), tries: 0 }));
    } catch (e) {}
  }
  function readKeptRecord() {
    try {
      var raw = sessionStorage.getItem(KEPT_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.lines || !o.lines.length || (o.t && Date.now() - o.t > KEPT_TTL) || (o.tries || 0) >= KEPT_TRIES) {
        sessionStorage.removeItem(KEPT_KEY);
        return null;
      }
      return o;
    } catch (e) { return null; }
  }
  function hasKept() { return !!readKeptRecord(); }

  function fetchWithTimeout(url, opts) {
    if (typeof AbortController === 'undefined') return fetch(url, opts);
    var ctl = new AbortController();
    var timer = setTimeout(function() { ctl.abort(); }, KEPT_REQ_MS);
    opts = opts || {};
    opts.signal = ctl.signal;
    return fetch(url, opts).then(function(r) { clearTimeout(timer); return r; }, function(e) { clearTimeout(timer); throw e; });
  }

  // 빠진 수량만 다시 담기 → Promise<{changed, ok}>
  // 멱등: 목표 수량을 매번 "지금 카트"에서 다시 계산하므로, 실패 후 다음 로드에서 재시도해도 이중으로 담기지 않음
  var keptRunning = null;
  function restoreKept() {
    if (keptRunning) return keptRunning;  // 같은 페이지에서 동시 호출(pageshow 등) → 하나로
    var rec = readKeptRecord();
    if (!rec) return Promise.resolve({ changed: false, ok: true });
    var lines = rec.lines;
    var keepRecord = false;
    function add(items) {
      return fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(res) { return res.ok; }, function() { return false; });
    }
    function readCart() {
      return fetchWithTimeout('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store', cache: 'no-store' })
        .then(function(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }
    function haveQty(cart, l) {
      return (cart.items || []).filter(function(i) {
        var plan = (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id) || 0;
        return i.variant_id === l.id && samePropsKept(i.properties, l.properties) && plan === (l.selling_plan || 0);
      }).reduce(function(n, i) { return n + i.quantity; }, 0);
    }
    function addItem(l, qty) {
      var copy = { id: l.id, quantity: qty };
      if (l.properties) copy.properties = l.properties;
      if (l.selling_plan) copy.selling_plan = l.selling_plan;
      return copy;
    }
    window.__azRestoring = true;  // cart-notification.js: 「カートに追加しました」 알림 생략
    // 목표 수량은 "처음 읽은 카트" 기준으로 한 번만 정함 → 다시 담은 뒤 확인할 때 방금 담은 수량을
    // 남겨 둔(keep) 수량으로 오인해 또 담는 이중 추가 방지
    var run = readCart().then(function(cart) {
      var plan = lines.map(function(l) {
        var have = haveQty(cart, l);
        var need = l.quantity - Math.max(0, have - (l.keep || 0));
        return need > 0 ? { line: l, target: have + need, need: need } : null;
      }).filter(Boolean);
      if (!plan.length) {
        // 뺄 줄이 아직 카트에 그대로 = 결제 직전 삭제 요청이 늦게 반영 중일 수 있음 → 잠시 기록 유지(다음 로드에서 재확인)
        if (Date.now() - (rec.t || 0) < KEPT_YOUNG) keepRecord = true;
        return { changed: false, ok: true };
      }
      function short(c) {
        return plan.map(function(x) {
          var lack = x.target - haveQty(c, x.line);
          return lack > 0 ? addItem(x.line, lack) : null;
        }).filter(Boolean);
      }
      return add(plan.map(function(x) { return addItem(x.line, x.need); }))
        .then(readCart)
        .then(function(cart2) {
          var still = short(cart2);
          if (!still.length) return { changed: true, ok: true };
          // 일부 실패(재고 등) → 부족분만 한 줄씩 재시도 후 최종 확인
          return still.reduce(function(p, it) { return p.then(function() { return add([it]); }); }, Promise.resolve())
            .then(readCart)
            .then(function(cart3) { return { changed: true, ok: short(cart3).length === 0 }; });
        });
    }).catch(function() { return { changed: true, ok: false }; });  // 확인 불가 → 카트를 다시 그려 실제 상태를 보여 줌

    keptRunning = run.then(function(r) {
      window.__azRestoring = false;
      keptRunning = null;
      try {
        if (!r.ok) {
          // 실패 → 다음 로드에서 한 번 더(멱등). 횟수 초과 시 readKeptRecord 가 삭제
          rec.tries = (rec.tries || 0) + 1;
          if (rec.tries >= KEPT_TRIES) sessionStorage.removeItem(KEPT_KEY);
          else sessionStorage.setItem(KEPT_KEY, JSON.stringify(rec));
          r.retry = rec.tries < KEPT_TRIES;
        } else if (!keepRecord) {
          sessionStorage.removeItem(KEPT_KEY);
        }
      } catch (e) {}
      return r;
    });
    return keptRunning;
  }

  // 장바구니 리로드를 넘어 안내를 전달
  function saveNotice(n) {
    if (!n) return;
    try { sessionStorage.setItem(NOTICE_KEY, JSON.stringify(n)); } catch (e) {}
  }
  function takeNotice() {
    try {
      var raw = sessionStorage.getItem(NOTICE_KEY);
      sessionStorage.removeItem(NOTICE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function toast(text) {
    if (!text) return;
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.textContent = text;
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
      'max-width:calc(100% - 32px);width:max-content;padding:12px 16px;background:rgba(17,17,17,.92);color:#fff;' +
      'font-size:13px;line-height:1.5;word-break:keep-all;overflow-wrap:anywhere;';
    document.body.appendChild(el);
    setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 6000);
  }

  window.azCoupon = {
    isPointCode: isPointCode,
    fetchCart: fetchCart,
    setCodes: setCodes,
    appliedCodes: appliedCodes,
    isApplied: isApplied,
    hasAttempt: hasAttempt,
    recoverPending: recoverPending,
    recordAttempt: recordAttempt,
    resolve: resolve,
    switchTo: switchTo,
    applyInPlace: applyInPlace,
    saveKept: saveKept,
    hasKept: hasKept,
    restoreKept: restoreKept,
    bestNeedsSync: bestNeedsSync,
    bestPointUpdateAttrs: bestPointUpdateAttrs,
    bestSync: bestSync,
    bestSetEnabled: bestSetEnabled,
    bestRemovalAttrs: bestRemovalAttrs,
    saveNotice: saveNotice,
    takeNotice: takeNotice,
    toast: toast
  };

  // 장바구니가 아닌 페이지: 기획전 등에서 /discount/ 를 거쳐 돌아왔으면 결과를 토스트로 안내.
  // (장바구니 페이지는 cart-amondz.js 가 직접 resolve — 안내 위치와 리로드를 거기서 제어)
  // 결제 때 뺀 미선택 상품도 여기서 다시 담음 — 쿠폰 결과 해석은 다시 담기가 끝난 뒤(바뀐 카트 기준으로 판정)
  function autoResolve() {
    if (document.querySelector('[data-az-cart]')) return;
    var restored = hasKept()
      ? restoreKept().then(function(r) {
          // azSilent: cart-notification.js 가 「追加しました」 알림을 띄우지 않음 (헤더 개수·드로어만 갱신)
          if (r.changed) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { azSilent: true } }));
        })
      : Promise.resolve();
    restored.then(function() {
      // 장바구니를 거치지 않고 결제로 가는 경우(드로어 등)도 새 방문이면 지난 자동 코드 정리 — 탭당 1회만 카트 조회
      var visited = true;
      try { visited = !!sessionStorage.getItem(bestVisitKey()); } catch (e) {}
      if (!visited && !hasAttempt()) {
        return fetchCart().then(bestVisitReset).then(function(reset) {
          if (reset) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { azSilent: true } }));
        });
      }
      if (!hasAttempt()) return;
      return fetchCart().then(resolve).then(function(res) {
        if (res && res.notice) toast(res.notice.text);
      });
    }).catch(function() {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoResolve);
  } else {
    autoResolve();
  }
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(bestHintRefresh).observe(document.documentElement, { childList: true, subtree: true });
  }
  // 결제 화면에서 뒤로가기로 장바구니 외 페이지가 복원(bfcache)되면 스크립트가 다시 돌지 않음 → 여기서 다시 담기
  window.addEventListener('pageshow', function(e) {
    if (e.persisted && hasKept()) autoResolve();
  });
})();
